import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const address = siteConfig.contact.address;
  const formattedAddress = `${address.line1}, ${address.postalCode} ${address.city}, ${address.country}`;
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-brand-panel">
        <div className="footer-brand-copy">
          <Link className="footer-logo" to="/" aria-label={`${siteConfig.brandName} home`} onClick={toTop}>{siteConfig.logo.text}</Link>
          <p className="footer-description">{siteConfig.description}</p>
          <p className="footer-impact-copy">Thoughtfully selected paper goods for work, study, and everyday creativity.</p>
        </div>
        <div className="footer-newsletter" aria-labelledby="footer-support-title">
          <p className="footer-newsletter-eyebrow">Customer care</p>
          <h2 className="footer-newsletter-title" id="footer-support-title">Questions about your order?</h2>
          <p className="footer-newsletter-copy">Our customer care team usually replies within two business days.</p>
          <a className="footer-newsletter-button" href={`mailto:${siteConfig.contact.email}`}>Email support</a>
        </div>
      </div>
      <div className="footer-navigation">
        {[["Shop", siteConfig.navigation.shop], ["Company", siteConfig.navigation.company], ["Help", siteConfig.navigation.help], ["Policies", siteConfig.navigation.policies]].map(([title, links]) => (
          <section className="footer-navigation-group" key={title}>
            <h2 className="footer-navigation-heading">{title}</h2>
            <div className="footer-navigation-links">{links.map((item) => <Link className="footer-navigation-link" key={`${item.label}-${item.path}`} to={item.path} onClick={toTop}>{item.label}</Link>)}</div>
          </section>
        ))}
        <section className="footer-navigation-group" aria-labelledby="footer-payment-heading">
          <h2 className="footer-navigation-heading" id="footer-payment-heading">Secure payments</h2>
          <div className="footer-payment-methods" aria-label="Supported payment methods">{["Visa", "Mastercard", "American Express", "JCB", "UnionPay"].map((method) => <span key={method}>{method}</span>)}</div>
        </section>
      </div>
      <div className="footer-bottom">
        <p className="footer-copyright">© {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.</p>
        <div className="footer-contact">
          <a className="footer-contact-link" href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
          <address>{formattedAddress}</address>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
